// extracted by mini-css-extract-plugin
module.exports = {"emojiTimeline":"emoji-timeline_emojiTimeline_3KN"};